export default function ProblemSection() {
  const problems = [
    {
      stat: '87%',
      label: 'of brand crises originate in the supply chain',
      icon: 'ri-alarm-warning-line',
      title: 'Hidden Risks Grow Without Representation',
      desc: "A single viral video from a factory floor can undo a decade of brand building. You can't control what you can't see.",
    },
    {
      stat: '$8K+',
      label: 'average cost per trip to China',
      icon: 'ri-flight-takeoff-line',
      title: 'Traveling for Oversight Costs Time and Money',
      desc: "Flights, hotels, translators, lost executive time, and you still only see what they prepare for you to see.",
    },
    {
      stat: '360',
      label: 'days per year with zero visibility',
      icon: 'ri-eye-off-line',
      title: 'Scheduled Audits Are Theater',
      desc: "Factories know exactly when you're coming. They clean up, hide issues, and perform. You see a show, not reality.",
    },
  ];

  return (
    <section id="problem" className="py-28 bg-[#F5F0E6]">
      <div className="max-w-6xl mx-auto px-6 lg:px-16">
        <div className="max-w-2xl mb-16">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-8 h-[1px] bg-[#D98C74]"></span>
            <span className="text-[#D98C74] text-[12px] font-semibold tracking-[0.2em] uppercase">
              The Stakes
            </span>
          </div>
          <h2
            className="text-[30px] lg:text-[40px] font-bold text-[#2C3E50] leading-[1.15] mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            How You Do Things in China Can Make or Break Your Brand
          </h2>
          <p className="text-[#2C3E50]/60 text-[16px] leading-[1.7]">
            Brands thousands of kilometers away from their factories often rely on assumptions and staged reports. Without a person in China who truly represents your interests, costly problems can go unseen until it's too late.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {problems.map((p) => (
            <div
              key={p.title}
              className="bg-white rounded-lg p-8 border border-[#D98C74]/15 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-11 h-11 flex items-center justify-center bg-[#D98C74]/10 rounded-lg">
                  <i className={`${p.icon} text-[#D98C74] text-xl`}></i>
                </div>
                <div>
                  <div className="text-[28px] font-bold text-[#2C3E50]">{p.stat}</div>
                  <div className="text-[12px] text-[#2C3E50]/40 leading-tight">{p.label}</div>
                </div>
              </div>
              <h3 className="text-[18px] font-bold text-[#2C3E50] mb-3">{p.title}</h3>
              <p className="text-[#2C3E50]/60 text-[14px] leading-[1.7]">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
